module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-force-rebook"
  }, [_c('ModalReveal', {
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Toggle hidden on map")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Toggle hidden on map")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-8"
  }, [_c('h2', [_vm._v("V" + _vm._s(_vm.vehicle.id) + " " + _vm._s(_vm.vehicle.brand) + " " + _vm._s(_vm.vehicle.model))]), _c('h2', [_vm._v(_vm._s(_vm.vehicle.plate))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column small-4"
  }, [_c('label', [_vm._v("Hidden")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.hidden),
      expression: "body.hidden"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.hidden) ? _vm._i(_vm.body.hidden, null) > -1 : (_vm.body.hidden)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.hidden,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "hidden", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "hidden", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "hidden", $$c)
        }
      }
    }
  })])])]), _c('ActionButton', {
    attrs: {
      "action": _vm.toggleHidden
    }
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33a428d9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/ToggleHiddenOnMap.vue
// module id = 2383
// module chunks = 1